export enum FONTS {
    OPEN_SANS = 'open-sans, sans-serif',
    ARISTOTELICA = 'aristotelica, sans-serif',
    ARTISTOTELICA_EXTRALIGHT = 'aristotelica-extralight, sans-serif',
    ROBOTO = 'roboto, sans-serif',
    ROBOTO_BOLD = 'roboto-bold, sans-serif',
    MONTSERRAT = 'montserrat, sans-serif',
    MONTSERRAT_BOLD = 'montserrat-bold, sans-serif',
    LATO = 'lato, sans-serif'
}

export enum FONT_SIZE {
    EXTRA_SHORT = '9px',
    SHORT = '13px',
}
